import React, { useMemo, useRef, useState,useEffect } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  Badge,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { Link } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import { formatDateTime } from "../../../utils/dayjs";
import "../../../assets/css/individual-cart.css";
const ManageTicket = () => {
  
    document.title = "Tickets | Vekart";
    const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;
    const [ticketsData, setTicketsData] = useState([]);
    const [error, setError] = useState(null);
const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);

     const fetchTicketsData = async () => {
  try {
          setError(null);
          const response = await fetch(`${baseurl}/admin/tickets/lists`);
          if (!response.ok) throw new Error("Network response was not ok");
          const data = await response.json();
          setTicketsData(data);
        } catch (error) {
          setError(error.message);
        }
      };
    
      useEffect(() => {
        fetchTicketsData();
      }, []);

const filteredData = useMemo(() => {
  if (!statusFilter) return ticketsData;

  return ticketsData.filter(
    item => item.status?.toLowerCase() === statusFilter.toLowerCase()
  );
}, [ticketsData, statusFilter]);
  const columns = useMemo(
  () => [
    {
      Header: "Department",
      accessor: "department",
      Cell: ({ value }) => <span>{value}</span>,
    },
    {
      Header: "Subject",
      accessor: "subject",
      Cell: ({ row }) => (
        <div>
          <Link
            to={`/tickets/view/${row.original.id}`}
            className="fw-bold text-primary"
          >
            #{row.original.id}
          </Link>
          <div className="text-muted" style={{ fontSize: "12px" }}>
            {row.original.subject}
          </div>
        </div>
      ),
    },
    {
  Header: "Company Name",
  accessor: "company_name",
},{
  Header: "Customer Name",
  accessor: "customer_name",
  Cell: ({ row }) => (
    <div>
      <div className="fw-bold">{row.original.customer_name}</div>
      <div className="text-muted" style={{ fontSize: "12px" }}>
        {row.original.contact_no}
      </div>
    </div>
  ),
},

{
  Header: "No",
  accessor: "no",
  Cell: ({ value }) => value ? `#${value}` : "-",
},
    {
      Header: "Priority",
      accessor: "priority",
      Cell: ({ value }) => {
        let color = "secondary";

        if (value === "Low") color = "success";
        else if (value === "Medium") color = "warning";
        else if (value === "High") color = "danger";

        return <Badge color={color}>{value}</Badge>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => {
        let color = "secondary";

        if (value === "Open") color = "success";
        else if (value === "Replied") color = "warning";
        else if (value === "Closed") color = "danger";

        return <Badge color={color}>{value}</Badge>;
      },
    },
    {
      Header: "Last Updated",
      accessor: "updated_at",
      Cell: ({ value }) => (
        <span>{formatDateTime(value)}</span>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      Cell: ({ row }) => (
        <div className="d-flex gap-3">
          <Link
            to={`/tickets/view/${row.original.id}`}
            className="text-success"
          >
            <i className="mdi mdi-eye-outline font-size-18"></i>
          </Link>

         {/* <Link
            to={`/tickets/reply/${row.original.id}`}
            className="text-primary"
          >
            <i className="mdi mdi-reply font-size-18"></i>
          </Link> */}
        </div>
      ),
    },
  ],
  []
);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Product" breadcrumbItem="Manage Tickets" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="status-filter-wrapper">
                <select name="filter"
                  className="status-filter"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
        <option value="">All</option>
        <option value="Open">Open</option>
        <option value="Pending">Pending</option>
        <option value="Replied">Replied</option>
        <option value="Resolved">Resolved</option>
        <option value="Closed">Closed</option>
      </select>
    </div>
                  <TableContainer
                    columns={columns}
                    data={filteredData}
                    isGlobalFilter={true}
                    customPageSize={10}
                    isAddProduct={false}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};


export default withRouter(ManageTicket);
